"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/LanguageOfferDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _translation = require('shared/selectors/translation');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Button = require('web/components/Form/Button/Button');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');





/* After Translate on a message from a patient with no language saved: "Set
 * Rosa's language to French?". Set language sets it for the patient (every
 * chat with them); Not now, or closing the dialog, changes nothing. */
const LanguageOfferDialog = ({ conversationKey }) => {
  const offer = _hooks.useAppSelector.call(void 0, state => _translation.selectLanguageOffer.call(void 0, state, conversationKey))
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  // Focus moves into the dialog, onto Set language.
  const setButtonRef = _react.useRef(null)
  _react.useEffect.call(void 0, () => {
    if (offer) _optionalChain([setButtonRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.focus, 'call', _3 => _3()])
  }, [offer])

  // answerLanguageOffer never rejects.
  const onNotNow = _react.useCallback.call(void 0, () => { _actions2.default.answerLanguageOffer(false).catch(() => undefined) }, [])
  const onSetLanguage = _react.useCallback.call(void 0, () => {
    _actions2.default.answerLanguageOffer(true).then((notice) => { if (notice) showWarningBar(notice) }).catch(() => undefined)
  }, [showWarningBar])

  if (!offer) return null
  const { title, body } = _translation.getLanguageOfferCopy.call(void 0, offer)
  return (
    _react2.default.createElement(_Modal2.default, { title: title, size: "xs", isOpen: true, onClose: onNotNow, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 39}},  body )
      , _react2.default.createElement('div', { className: "blm-modal--buttons-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
        , _react2.default.createElement('button', { type: "button", className: _classBuilder2.default.call(void 0, _Button.btnClassName, _Button.secondaryBtnClassName), onClick: onNotNow, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}, "Not now"

        )
        , _react2.default.createElement('button', {
          ref: setButtonRef,
          type: "button",
          className: _classBuilder2.default.call(void 0, _Button.btnClassName, 'blm-btn--primary'),
          onClick: onSetLanguage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
, "Set language"

        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, LanguageOfferDialog)
